export interface AuditLog {
  id: number;
  action: string;
  user_name: string;
  target_user: string;
  created_at: string;
}

export interface RecoveryState {
  searchResults: any[];
  isSearching: boolean;
  auditLogs: AuditLog[];
}

export const state: RecoveryState = {
  searchResults: [],
  isSearching: false,
  auditLogs: [],
};
